module.exports = __webpack_public_path__ + "ecda6a0872994f3e3f9e473154656cf4.woff2";